import { Entitlement } from './entitlement-page-types';
import { BaseEntitlement } from '@atlassian/cssxp-typescommon';
import moment from 'moment';
import { EntitlementBaseProduct } from '@atlassian/cssxp-types-entitlement';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import { isTrialEntitlement, isStatusPageTrial } from './entitlement-summary/entitlment-summary-utils';

const getTrialEndDate = (entitlement: EntitlementDetails) => {
  const isStatusPage = entitlement.baseProduct === EntitlementBaseProduct.STATUS_PAGE;
  const isTrial = isTrialEntitlement(entitlement, isStatusPage);
  const isFreePlan = entitlement?.edition && entitlement?.edition.includes('Free');
  if (isFreePlan) {
    return '';
  }
  if (isTrial) {
    if (!isStatusPage && entitlement?.subscriptionTimestamps?.lastTrialEndTimestamp) {
      return entitlement?.subscriptionTimestamps?.lastTrialEndTimestamp;
    }
    if (isStatusPageTrial(entitlement) && entitlement?.latestPeriodEndDate) {
      return entitlement?.latestPeriodEndDate;
    }
  }
  return '';
};

const daysForTrialExpiry = (entitlement: EntitlementDetails) => {
  const currDate = moment.utc(new Date());
  const endDate = moment(getTrialEndDate(entitlement));
  const currentDate = moment(currDate);
  const diffDate = endDate.diff(currentDate, 'days');
  return diffDate;
};

export { daysForTrialExpiry, getTrialEndDate };
